export default __webpack_public_path__ + "72492e905c6c90251fbe654f9fd188ed.png";